










import { Vue, Prop, Component } from 'vue-property-decorator';

@Component
export default class Button extends Vue {
    @Prop({ type: Boolean }) isSecondary!: boolean;
    @Prop({ type: Boolean }) isBig!: boolean;
    @Prop({ type: Boolean }) isOutlined!: boolean;
    @Prop({ type: Boolean }) isLink!: boolean;
    @Prop({ type: Boolean }) isDisabled!: boolean;
    @Prop({ type: Boolean }) isSuccess!: boolean;
    @Prop({ type: Boolean }) isDanger!: boolean;
    @Prop({ type: Boolean }) isWarning!: boolean;
    @Prop({ type: Boolean }) isInfo!: boolean;
    @Prop({ type: Boolean }) isIcon!: boolean;
    @Prop() title!: string;

    private onClick() {
        if (!this.isDisabled) {
            this.$emit('click');
        }
    }

    private get btnClass(): { [key: string]: boolean } {
        const isPrimary = !this.isSecondary && !this.isSuccess && !this.isDanger && !this.isWarning && !this.isInfo;
        const isFilled = !this.isOutlined && !this.isLink;
        return {
            "border-transparent": isFilled || this.isLink,
            "text-button-text-filled dark:text-button-text-filled-dark": !this.isOutlined && !this.isLink,
            "abc-button-underlined": this.isLink,
            "effect-on-click": !this.isDisabled && !this.isLink,
            "auto-width": this.isIcon,


            "bg-primary-500 dark:bg-primary-dark-500": isPrimary && !this.isDisabled && isFilled,
            "bg-secondary-500 dark:bg-secondary-dark-500": this.isSecondary && !this.isDisabled && isFilled,
            "bg-success-500 dark:bg-success-dark-500": this.isSuccess && !this.isDisabled && isFilled,
            "bg-danger-500 dark:bg-danger-dark-500": this.isDanger && !this.isDisabled && isFilled,
            "bg-warning-500 dark:bg-warning-dark-500": this.isWarning && !this.isDisabled && isFilled,
            "bg-info-500 dark:bg-info-dark-500": this.isInfo && !this.isDisabled && isFilled,

            "hover:bg-primary-400": isPrimary && !this.isDisabled && isFilled,
            "hover:bg-secondary-400": this.isSecondary && !this.isDisabled && isFilled,
            "hover:bg-success-400": this.isSuccess && !this.isDisabled && isFilled,
            "hover:bg-danger-400": this.isDanger && !this.isDisabled && isFilled,
            "hover:bg-warning-400": this.isWarning && !this.isDisabled && isFilled,
            "hover:bg-info-400": this.isInfo && !this.isDisabled && isFilled,

            "bg-primary-300 dark:bg-primary-dark-300": isPrimary && this.isDisabled && isFilled,
            "bg-secondary-300 dark:bg-secondary-dark-300": this.isSecondary && this.isDisabled && isFilled,
            "bg-success-300 dark:bg-success-dark-300": this.isSuccess && this.isDisabled && isFilled,
            "bg-danger-300 dark:bg-danger-dark-300": this.isDanger && this.isDisabled && isFilled,
            "bg-warning-300 dark:bg-warning-dark-300": this.isWarning && this.isDisabled && isFilled,
            "bg-info-300 dark:bg-info-dark-300": this.isInfo && this.isDisabled && isFilled,


            "text-primary-500 dark:text-primary-dark-500": isPrimary && !this.isDisabled && (this.isOutlined || this.isLink),
            "text-secondary-600 dark:text-secondary-dark-600": this.isSecondary && !this.isDisabled && (this.isOutlined || this.isLink),
            "text-success-600 dark:text-success-dark-600": this.isSuccess && !this.isDisabled && (this.isOutlined || this.isLink),
            "text-danger-500 dark:text-danger-dark-500": this.isDanger && !this.isDisabled && (this.isOutlined || this.isLink),
            "text-warning-500 dark:text-warning-dark-500": this.isWarning && !this.isDisabled && (this.isOutlined || this.isLink),
            "text-info-500 dark:text-info-dark-500": this.isInfo && !this.isDisabled && (this.isOutlined || this.isLink),

            "border-primary-500 dark:border-primary-dark-500": isPrimary && !this.isDisabled && this.isOutlined,
            "border-secondary-500 dark:border-secondary-dark-500": this.isSecondary && !this.isDisabled && this.isOutlined,
            "border-success-500 dark:border-success-dark-500": this.isSuccess && !this.isDisabled && this.isOutlined,
            "border-danger-500 dark:border-danger-dark-500": this.isDanger && !this.isDisabled && this.isOutlined,
            "border-warning-500 dark:border-warning-dark-500": this.isWarning && !this.isDisabled && this.isOutlined,
            "border-info-500 dark:border-info-dark-500": this.isInfo && !this.isDisabled && this.isOutlined,

            "hover:bg-primary-100": isPrimary && !this.isDisabled && this.isOutlined,
            "hover:bg-secondary-100": this.isSecondary && !this.isDisabled && this.isOutlined,
            "hover:bg-success-100": this.isSuccess && !this.isDisabled && this.isOutlined,
            "hover:bg-danger-100": this.isDanger && !this.isDisabled && this.isOutlined,
            "hover:bg-warning-100": this.isWarning && !this.isDisabled && this.isOutlined,
            "hover:bg-info-100": this.isInfo && !this.isDisabled && this.isOutlined,

            "hover:text-primary-300": isPrimary && !this.isDisabled && this.isLink,
            "hover:text-secondary-400": this.isSecondary && !this.isDisabled && this.isLink,
            "hover:text-success-400": this.isSuccess && !this.isDisabled && this.isLink,
            "hover:text-danger-300": this.isDanger && !this.isDisabled && this.isLink,
            "hover:text-warning-300": this.isWarning && !this.isDisabled && this.isLink,
            "hover:text-info-300": this.isInfo && !this.isDisabled && this.isLink,

            "active:text-primary-800": isPrimary && !this.isDisabled && this.isLink,
            "active:text-secondary-800": this.isSecondary && !this.isDisabled && this.isLink,
            "active:text-success-800": this.isSuccess && !this.isDisabled && this.isLink,
            "active:text-danger-700": this.isDanger && !this.isDisabled && this.isLink,
            "active:text-warning-700": this.isWarning && !this.isDisabled && this.isLink,
            "active:text-info-700": this.isInfo && !this.isDisabled && this.isLink,

            "text-primary-200 dark:text-primary-dark-200": isPrimary && this.isDisabled && (this.isOutlined || this.isLink),
            "text-secondary-300 dark:text-secondary-dark-300": this.isSecondary && this.isDisabled && (this.isOutlined || this.isLink),
            "text-success-300 dark:text-success-dark-300": this.isSuccess && this.isDisabled && (this.isOutlined || this.isLink),
            "text-danger-200 dark:text-danger-dark-200": this.isDanger && this.isDisabled && (this.isOutlined || this.isLink),
            "text-warning-300 dark:text-warning-dark-300": this.isWarning && this.isDisabled && (this.isOutlined || this.isLink),
            "text-info-200 dark:text-info-dark-200": this.isInfo && this.isDisabled && (this.isOutlined || this.isLink),

            "border-primary-200 dark:border-primary-dark-200": isPrimary && this.isDisabled && this.isOutlined,
            "border-secondary-300 dark:border-secondary-dark-200": this.isSecondary && this.isDisabled && this.isOutlined,
            "border-success-300 dark:border-success-dark-200": this.isSuccess && this.isDisabled && this.isOutlined,
            "border-danger-200 dark:border-danger-dark-200": this.isDanger && this.isDisabled && this.isOutlined,
            "border-warning-300 dark:border-warning-dark-200": this.isWarning && this.isDisabled && this.isOutlined,
            "border-info-200 dark:border-info-dark-200": this.isInfo && this.isDisabled && this.isOutlined,


            "default-sized": !this.isBig,
            "big-sized": this.isBig,
            "cursor-not-allowed": this.isDisabled,
        };
    }

}
